export default __webpack_public_path__ + "static/media/805.f769dd03.gif";